import axios from 'axios'
import PepiteWeek from '../models/pepiteWeek'
import requestErrorServices from '../services/requestErrorServices'

export default class {
  // Charge la liste des pepite en fonction du partner
  static loadList () {
    return new Promise((resolve, reject) => {
      axios.get('/api/pepite/list', null)
        .then(function (response) {
          const packs = response.data.packs
          const weeks = response.data.weeks
          const tab = []
          for (let i = 0; i < weeks.length; i++) {
            for (let j = 0; j <= packs.length; j++) {
              if (packs[j].id === weeks[i].packId) {
                weeks[i].pack = packs[j]
                break
              }
            }
            const week = new PepiteWeek(weeks[i])
            tab.push(week)
          }
          resolve(tab)
        })
        .catch(function (error) {
          requestErrorServices.manageError(error)
          reject(error)
        })
    })
  }

  static book (campingId, weekId) {
    return new Promise((resolve, reject) => {
      axios.post('/api/pepite/book', {
        campingId: campingId,
        weekId: weekId
      }).then(function (response) {
        resolve(response)
      }).catch(function (error) {
        requestErrorServices.manageError(error)
        reject(error)
      })
    })
  }
}
